import { AccessType } from "./access-type";
import { Address } from "./address";
import { DockType } from "./dock-type";
import { SiteMode } from "./site-mode";
import { User } from "./user";
import { Zone } from "./zone";

export class Site {
    id?: string;
    name?: string;
    description?: string;
    zone?: Zone;
    zoneId?: string | null;
    area?: string;
    dockTypeId?: string | null;
    dockType?: DockType;
    accessTypeId?: string | null;
    accessType?: AccessType;
    siteModeId?: string | null;
    siteMode?: SiteMode;
    addressId?: string | null;
    address?: Address;

    latitude?: number;
    longitude?: number;
    disabled?: boolean;

    creationDate?: Date;
    creationUser?: User;

    modifiedDate?: Date;
    modifiedUser?: User;

    isPaco?: boolean;

    constructor(site?: Site) {
        this.id = site?.id;
        this.name = site?.name;
        this.description = site?.description;
        this.zoneId = site?.zoneId || (site?.zone ? site?.zone.id : null);
        this.zone = site?.zone;
        this.area = site?.area;
        this.dockTypeId = site?.dockTypeId || (site?.dockType ? site?.dockType.id : null);
        this.dockType = site?.dockType;
        this.accessTypeId = site?.accessTypeId || (site?.accessType ? site?.accessType.id : null);
        this.accessType = site?.accessType;
        this.siteModeId = site?.siteModeId || (site?.siteMode ? site?.siteMode.id : null);
        this.siteMode = site?.siteMode;
        this.addressId = site?.addressId || (site?.address ? site?.address.id : null);
        this.address = site?.address;
        this.latitude = site?.latitude;
        this.longitude = site?.longitude;
        this.disabled = site?.disabled;

        this.creationDate = site?.creationDate;
        this.creationUser = site?.creationUser;
        this.modifiedDate = site?.modifiedDate;
        this.modifiedUser = site?.modifiedUser;

        this.isPaco = site?.isPaco;
    }
}
